<template>
  <a-card :bordered="false" title="全国机票直连">
    <a-form-model :model="ruleForm" ref="ruleForm"
                  :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="同步状态" required>
        <a-radio-group name="radioGroup" v-model="ruleForm.airStatus">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'PlaneTickets',
  mixins: [ruleFormMixins],
  data() {
    return {
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      ruleForm: {
        airStatus: 1,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
    }
  },
  mounted() {
    this.getPlaneTickets()
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('air/editAirDistributorStatus', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('同步状态成功')
        this.getPlaneTickets()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getPlaneTickets() {
      this.getHttpServices().getServerApiService().get('air/getAirDistributorStatus?platformId=' + this.platformId + '&merchantId=' + this.merchantId).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm.airStatus = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">

</style>